import { useAppliedTransportTypeFilter } from '../Components/TransportTypeFilter/Provider';
import { useAppliedTimeFilter } from '../Components/TimeFilter/Provider';
import { useAppliedConnectionThresholdFilter } from '../Components/MaxStopsFilter/Provider';
import { useAppliedStopDurationFilter } from '../Components/StopDurationFilter/Provider';
import { useAppliedStopAirportFilter } from '../Components/StopAirportFilter/Provider';
import { useAppliedAirportFilter } from '../Components/AirportFilter/Provider';
import { useAppliedCarrierFilter } from '../Components/CarrierFilter/Provider';
import { usePrimeDayFilter } from '../Components/PrimeDayFilter/Provider';
import { useCarbonFootprintFilter } from '../Components/CarbonFootprintFilter/Provider';
import { useAppliedPriceFilter } from '@components/Filters/Components/PriceFilter/Provider';
import { useIsPinnedSegmentApplied } from '../../Results/Components/PinSegment/provider/pinSegmentProvider';
import { useIsAircraftFilterApplied } from '../Components/AircraftFilter/Provider/AircraftFilterProvider';

const useAppliedFiltersCounter = () => {
  const hasTransporTypeFilterApplied = useAppliedTransportTypeFilter();
  const { hasPrimeDayFilterApplied } = usePrimeDayFilter();
  const { hasCarbonFootprintFilterApplied } = useCarbonFootprintFilter();
  const hasTimeFilterApplied = useAppliedTimeFilter();
  const hasMaxStopsApplied = useAppliedConnectionThresholdFilter();
  const hasStopDurationFilterApplied = useAppliedStopDurationFilter();
  const hasStopAirportFilterApplied = useAppliedStopAirportFilter();
  const hasAirportFilterApplied = useAppliedAirportFilter();
  const hasCarrierFilterApplied = useAppliedCarrierFilter();
  const hasPriceFilterApplied = useAppliedPriceFilter();
  const isPinnedSegmentApplied = useIsPinnedSegmentApplied();
  const isAircraftFilterApplied = useIsAircraftFilterApplied();

  return [
    hasTransporTypeFilterApplied,
    hasPrimeDayFilterApplied,
    hasCarbonFootprintFilterApplied,
    hasTimeFilterApplied,
    hasMaxStopsApplied,
    hasStopDurationFilterApplied,
    hasStopAirportFilterApplied,
    hasAirportFilterApplied,
    hasCarrierFilterApplied,
    hasPriceFilterApplied,
    isPinnedSegmentApplied,
    isAircraftFilterApplied,
  ].filter(Boolean).length;
};

export default useAppliedFiltersCounter;
